<div class="login-block">
  <app-logo-card></app-logo-card>
  <mat-card class="login-card">
    <mat-card-content>
      <form #loginForm="ngForm"
            class="login-form" (ngSubmit)="submitLogin($event)">
        <mat-form-field>
          <input matInput
            type="email"
            name="email"
            placeholder="メールアドレス"
            id="inputEmail"
            [(ngModel)]="account.email"
            #email="ngModel"
            autocomplete="username email"
            required>
          <mat-label class="form-error" *ngIf="email.errors?.required">
            必須です
          </mat-label>
        </mat-form-field>

        <mat-form-field>
          <input matInput
            [type]="!showPassword ? 'password' : 'text'"
            placeholder="パスワード"
            id="inputPassword"
            [(ngModel)]="account.password"
            name="password"
            #password="ngModel"
            required>
<!--          https://j-xaas.github.io/Angular-mat-input-password%E3%81%AE%E8%A1%A8%E7%A4%BA-%E9%9D%9E%E8%A1%A8%E7%A4%BA-%E3%82%92%E5%88%87%E3%82%8A%E6%9B%BF%E3%81%88%E3%82%8B%E3%82%A2%E3%82%A4%E3%82%B3%E3%83%B3%E3%82%92%E5%AE%9F%E8%A3%85/-->
          <!--目のアイコンの押下で入力値の表示を切り替え--->
          <button mat-icon-button
                  matSuffix type="button"
                  (click)="showPassword = !showPassword"
                  [attr.aria-label]="'Hide password'"
                  [attr.aria-pressed]="showPassword"
          >
            <mat-icon>{{showPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>

          <mat-label class="form-error" *ngIf="password.errors?.required">
            必須です
          </mat-label>

        </mat-form-field>
        <button mat-button
          type="submit"
          color="primary"
          [disabled]="loginForm.invalid">
          ログイン
        </button>
      </form>
      <div style="padding-top: 10px; text-align: center">
        <button mat-button color="light" (click)="sendPasswordResetEmail(account.email)">パスワード再設定メールを送る</button>
      </div>
    </mat-card-content>
  </mat-card>
</div>
